var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marker",class:{
        [`marker--${_vm.type}`]: true,
        'is-active': _vm.isActive,
    }},[_c('div',{staticClass:"marker__inner"},[(_vm.type === _vm.$options.MAP_MARKER_TYPES.SINGLE)?_c('v-icon',{staticClass:"marker__icon",attrs:{"color":_vm.isActive ? 'primary' : 'grey darken-3'}},[_vm._v(" mdi-map-marker ")]):_c('v-icon',{staticClass:"marker__icon",attrs:{"color":_vm.isActive ? 'primary' : 'grey darken-3'}},[_vm._v(" icon-marker ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }